<template>
  <div class="search_view">
    <div class="sidebar">
      <Sidebar />
    </div>
    <div class="center">
      <div v-if="loaded">
        <div class="content">
          <Active-filters />
          <span v-if="empty == true"
            >Niestety nie znaleźliśmy żadnych samochodów spełniających dane
            kryteria</span
          >

          <CarListItem v-for="offer in offers" :key="offer" :car_data="offer" />

          <Trigger v-if="loaded" @triggerIntersected="getMoreOffers" />
        </div>
      </div>
      <div v-else>
        <img src="../assets/animation_ac.gif" class="spinner" />
      </div>
    </div>
  </div>
</template>


<script>
import Sidebar from "@/components/Sidebar.vue";
import ActiveFilters from "@/components/ActiveFilters.vue";

import CarListItem from "@/components/CarListItem.vue";
import Trigger from "@/components/Trigger.vue";

import axios from "axios";
export default {
  data() {
    return {
      offers: [],
      page: 1,
      max_page: 0,
      empty: false,
      no_tariff: false,
      loaded: false,
      lot_number: undefined,
      vin_number: undefined,
      requests_left: 0,
      todays_date: new Date().toJSON().slice(0, 10),
      selected: {
        car_brand: this.$route.query.car_brand,
        car_model: this.$route.query.car_model,
        year_from: this.$route.query.year_from,
        year_to: this.$route.query.year_to,
        vehicle_type: this.$route.query.vehicle_type,
        odometer_from: "0",
        odometer_to: "100000",
        auction_name: this.$route.query.auction_name,
        auction_date_from: "2000-12-08",
        auction_date_to: "2000-12-08",
        estimated_retail_value_from: 0,
        estimated_retail_value_to: 10000,
      },
    };
  },
  beforeMount() {
    this.check_parmas();
    this.getOffers();
  },
  methods: {
    async check_parmas() {
      this.lot_number = this.$route.query.lot_number;
      this.vin_number = this.$route.query.vin_number;
      if (this.lot_number != undefined) {
        this.$router.push({
          name: "auction",
          params: {
            id: parseInt(this.$route.query.lot_number),
          },
        });
      }
      if (this.vin_number != undefined) {
        this.$router.push({
          name: "search_vin",
          query: {
            vin_number: this.vin_number,
          },
        });
      }
    },
    async getOffers() {
      this.loaded = false;
      console.log(this.selected);
      if (this.selected.year_from != undefined) {
        this.selected.year_from = this.selected.year_from.toString();
      }

      if (this.selected.year_to != undefined) {
        this.selected.year_to = this.selected.year_to.toString();
      }
      var { data } = await axios.post(
        process.env.VUE_APP_API_HOST + "/get-cars",
        {
          api_token: "string",
          make: this.selected.car_brand,
          model: this.selected.car_model,
          year_from: this.selected.year_from,
          year_to: this.selected.year_to,
          auction_name: this.selected.auction_name,
          auction_date_from: this.todays_date,
          auction_date_to: " 2050-01-01",
          sale_price_from: 0,
          sale_price_to: 0,
          created_at_from: "string",
          created_at_to: "string",
          odometer_from: this.selected.odometer_from,
          odometer_to: this.selected.odometer_to,
          vehicle_type: this.selected.vehicle_type,
          per_page: 20,
          page: this.page,
        },
        {
          headers: {
            "X-API-Key": process.env.VUE_APP_API_KEY,
          },
        }
      );
      console.log(data);
      this.requests_left = data["apiRequestLeft"];
      if (data["message"] == "No active tariff found.") {
        this.no_tariff = true;
      } else {
        if (data["pagination"]["total"] == 0) {
          this.empty = true;
        } else {
          this.empty = false;
        }
        this.max_page = data["pagination"]["total_pages"];
        this.offers = data["result"];
        console.log(this.offers);
        this.loaded = true;
      }
    },
    async getMoreOffers() {
      console.log("load more");
      this.page++;
      if (this.page <= this.max_page) {
        var { data } = await axios.post(
          process.env.VUE_APP_API_HOST + "/get-cars",
          {
            api_token: "string",
            make: this.selected.car_brand,
            model: this.selected.car_model,
            year_from: this.selected.year_from,
            year_to: this.selected.year_to,
            auction_name: this.selected.auction_name,
            auction_date_from: this.todays_date,
            auction_date_to: "2050-01-01",
            sale_price_from: 0,
            sale_price_to: 0,
            created_at_from: "string",
            created_at_to: "string",
            odometer_from: this.selected.odometer_from,
            odometer_to: this.selected.odometer_to,
            per_page: 20,
            page: this.page,
          },
          {
            headers: {
              "X-API-Key": process.env.VUE_APP_API_KEY,
            },
          }
        );
        console.log(data);
        this.offers = this.offers.concat(data["result"]);
        console.log(this.offers);
      } else {
        console.log("last page");
      }
    },
  },
  components: {
    CarListItem,
    Trigger,
    Sidebar,
    ActiveFilters,
  },
};
</script>
<style scoped>
.select_brand h3,
label,
.search_view .sidebar .select_brand p,
.radio_box label,
.car_list_item .info_box .first_row a h2,
.car_list_item .info_box .info_price {
  color: #011f68;
}

.search_view {
  display: grid;
  grid-auto-columns: 1fr;
  grid-template-columns: 420px 1fr;
  gap: 0px 0px;
  background: #edf2f7;
}
.sidebar {
  border: 4px solid #edf2f7;
  width: 100%;
  padding-top: 10px;
}
.center {
  background: #edf2f7;
  width: 100%;
}
.spinner {
  height: 100px;
  margin: auto;
  display: block;
}
select[name="vehicle"] {
  border: 2px solid #edf2f7;
  padding: 9px;
  text-align: center;
  width: 150px;
}

@media only screen and (max-width: 1000px) {
  .search_view {
    grid-template-columns: 1fr;
  }
}

@media only screen and (min-width: 600px) {
  .search_view .center .content {
    padding: 30px;
  }

  .search_view .center {
    padding: 0;
  }
}
</style>
<style >
@media (max-width: 1399px) {
  .search_view .dropdown-box {
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: center;
    gap: 5px;
  }

  .search_view .car_list_item .info_box .first_row .flex {
    flex-direction: row;
    align-items: center;
    gap: 5px 10px;
  }

  .search_view .car_list_item .info_box .flex {
    flex-direction: column;
    align-items: flex-start;
  }

  .search_view .info-details {
    width: 100%;
  }
}

@media (max-width: 1199px) {
  .search_view .car_list_item .info_box .first_row a h2 {
    margin-bottom: 5px;
  }

  .search_view .car_list_item .info_box .first_row .flex {
    flex-direction: column;
    align-items: flex-start;
  }

  .search_view .car_list_item .info_box .first_row .flex .vin {
    margin-top: 0;
  }

  .search_view .car_list_item {
    gap: 20px;
  }

  .search_view .info-details {
    grid-template-columns: 1fr;
  }

  .search_view .car_list_item .image_box {
    width: 250px;
  }
}

@media (max-width: 1000px) {
  .search_view .dropdown-box {
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: center;
    gap: 5px;
  }

  .search_view .info-details {
    grid-template-columns: 1fr 1fr;
  }
}

@media (max-width: 799px) {
  .search_view .info-details {
    width: 100%;
  }

  .search_view .offer {
    width: auto;
  }

  .search_view .car_list_item .image_box {
    width: 100%;
  }
}

@media (max-width: 599px) {
  .search_view .center .content {
    padding-right: 15px;
    padding-left: 15px;
  }

  .search_view .active-filters {
    margin-bottom: 30px;
  }

  .search_view .info-details {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 576px) {
  .search_view .select_auction {
    justify-content: flex-start;
  }

  .search_bar h3 {
    font-size: 28px;
    line-height: 36px;
  }

  .search_view .dropdown-box {
    width: 100%;
  }
}

@media (max-width: 460px) {
  .search_bar .year {
    grid-template-columns: 1fr;
    gap: 0;
  }

  .search_view .input {
    width: 90px;
  }

  .search_view .dropdown {
    width: 110px;
  }

  .search_view .multiselect__select {
    width: 30px;
  }

  .search_view .multiselect__tags {
    padding-right: 30px;
  }
}

@media (max-width: 360px) {
  .search_view .car_list_item .image_box {
    height: auto;
  }
}
</style>
